import { Button } from '@mui/material';

// import { UseLayerDashboardStore } from '../stores/useLayerDashboardStore';
import { useLayerDashboardTabStore } from '../context/LayerDashboardContext';

export function TitleChart({title, maximizeOperation}:{title: string, maximizeOperation:string}) {
    const [maximizedView, setMaximizedView] = useLayerDashboardTabStore(state => [state.maximizedView, state.setMaximizedView]);
    return <div style={{fontSize: 22, backgroundColor: 'rgb(4, 31, 60)', borderRadius: '5px', color: 'white', textAlign: 'center'}}>
        {title}
        {/*
            maximizeOperation ?? <Button style={{color: 'white'}} onClick={() => setMaximizedView(maximizedView === maximizeOperation ? '' : maximizeOperation)}>
                {maximizedView === maximizeOperation ? 'Restaurar' : '000Maximizar'}
            </Button>
            */
        }
    </div>;
}